import api from "../services/api";
import { IUser } from "../models/IUser";

export const login = (data: { email: string; password: string }) => api.post("auth/login", data);

export const assignRole = (data: {email: string, role: string}) => api.post("auth/assign-role", data);

export const getCurrentUser = (): Promise<{ data: IUser }> => api.get("auth/me");
